import { defineFcm } from '../shared/factory';

export const FCM_PHOTO_RESIZE_USE_VIPS = defineFcm('photo_resize_use_vips')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'monorail',
		supportedGroups: { global: true },
		context: 'Photo resize/crop pipeline',
		description:
			'Global on/off switch for using libvips instead of ImageMagick/MiniMagick to generate photo derivatives (resize/crop) in the Rails monolith. Part of a migration off MiniMagick; defaults off and will be rolled out via a staging soak first before enabling in production. See CHANGE-99402.',
	});
